
<app-general-case *ngIf="user.user_type.type.toLowerCase() != 'translator'"></app-general-case>
<app-translator-case [caseAssignmentId]="caseAssignmentId" *ngIf="user.user_type.type.toLowerCase() == 'translator'"></app-translator-case>
